module.exports = __webpack_public_path__ + "static/media/file-desc.8744d06e.svg";